module.exports = __webpack_public_path__ + "img/logo-kemiocode.a2b2f73b.png";